import { useState, useEffect } from "react";
import { Button } from "../ui/button";
import { CarouselDestacados } from "./carousel-destacados";
export const Destacados = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const loadProducts = async () => {
      try {
        const response = await fetch(
          process.env.REACT_APP_URL + "api/menu?name=mariposa",
        );

        if (!response.ok) {
          throw new Error({
            message: "Ocurrio un error al intentar cargar los productos.",
          });
        } else {
          let { data } = await response.json();

          [data] = data;
          setProducts(data);
        }
      } catch (err) {}
    };
    loadProducts();
  }, []);
  return (
    <div
      id="especiales"
      className="w-full  py-20  max-h-screen px-10 bg-white  flex flex-col mb-20"
    >
      <h1 className="font-extrabold font-Lato text-subtle text-[40px] lg:text-[50px] xl:text-[60px] text-center mb-5">
        Especiales de la Casa
      </h1>
      <div className="px-2 w-full max-h-[500px]">
        <CarouselDestacados products={products} />
      </div>
    </div>
  );
};
